import React, { Component } from 'react'
import { Row, Col } from 'antd'
import _ from 'lodash'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'

class Index extends Component {

	componentDidMount() {
		this.props.subscribeToExportProgress()
	}

	render() {
		const { isExporting, exportProgress } = this.props

		if (_.has(exportProgress, 'file_path')) {
			window.open(`${process.env.REACT_APP_BACKEND_API}${exportProgress.file_path}`, '_blank')
		}
		return (
			<React.Fragment>
				{
					isExporting &&
					<div className="alert alert-icon alert-warning alert-dismissible fade show" role="alert">
						<i className="mdi mdi-alert mr-2"></i>
						{exportProgress.message}
					</div>
				}
			</React.Fragment>
		)
	}
}

const composed = compose(
	inject('AuthStore'),
	observer
)

export default composed(Index)